import { render } from "./public.svg?vue&type=template&id=2737e244?inline"
const script = {}
script.render = render

export default script